import React from 'react'
import PropTypes from 'prop-types'

const TableSearch = ({ search, setSearchTerm, cy }) => {
  return (
    <div className='col form-group mb-0'>
      <input className='form-control mb-0' placeholder='Search...' value={search} onChange={setSearchTerm} data-cy={cy} />
    </div>
  )
}

TableSearch.propTypes = {
  search: PropTypes.string,
  setSearchTerm: PropTypes.func,
  cy: PropTypes.string
}

export default TableSearch
